import { AppFooter } from './app-footer/app-footer';
import { AppHeader } from './app-header/app-header';
import { StyledContent, StyledLayout } from './app-layout.style';

const AppLayout = ({ children }: React.PropsWithChildren) => {
    return (
        <StyledLayout>
            <AppHeader />

            <StyledContent>
                {children}
            </StyledContent>

            <AppFooter />
        </StyledLayout>
    )
}

export default AppLayout;